(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('CountriesWithoutPostcodeService', CountriesWithoutPostcodeService);

    CountriesWithoutPostcodeService.$inject = ['$resource'];

    function CountriesWithoutPostcodeService ($resource) {
        var service = $resource('/content/json/countries-without-postcode.json', {}, {
            'query': {method: 'GET', isArray: false,ignoreLoadingBar: true},
            'get': {
                method: 'GET',
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;

    }
})();
